import type { State, Actions } from './types'
import { FETCHED } from 'store/menus/actionTypes'
import schema from './schema'
import {
  GENERAL,
  LOGIN_BUTTON,
  LOGIN_FORM,
  POLICY_BANNER,
  COMMENTS,
  SOCIAL,
  COMPONENTS,
  PATHS,
  REGISTER_FORM,
} from './strings'

const initialState = {
  [GENERAL]: {},
  [LOGIN_BUTTON]: {},
  [LOGIN_FORM]: {},
  [POLICY_BANNER]: {},
  [COMMENTS]: {},
  [SOCIAL]: {},
  [COMPONENTS]: {},
  [PATHS]: {},
  [REGISTER_FORM]: {},
}

export default function (
  state = initialState as State,
  action: Actions,
): State {
  switch (action.type) {
    case FETCHED: {
      const results = schema(action.payload)
      return results
    }
    default:
      return state
  }
}
